import React from 'react';
import styled from 'styled-components';
import control from '../../../../../vendor/react-validation/hocs/control';

import definitions from '../../../../Style/LfStyleDefinitions';

import {iconCode, mediaQuery, clearFix} from '../../../../Style/cssHelpers';

export const TextInput = ({ error, isChanged, isUsed, ...allProps }) => {
    const { displayname, fieldWidth, textInputWrapperWidth, marginBottom, inlineBlock, ...props} = allProps;

    return (
        <TextInputWrapper
            fieldWidth={fieldWidth}
            marginBottom={marginBottom}
            inlineBlock={inlineBlock}
            textInputWrapperWidth={textInputWrapperWidth}>

            <input type="text" {...props} {...( isChanged && isUsed && error ? {
                className: `is-invalid-input ${props.className}`
            } : { className: props.className } )} />
            
            <span></span>
            
            {displayname &&
                <label htmlFor={props.id}>{displayname}</label>
            }

            {isChanged && isUsed && error}    
        </TextInputWrapper>
    );
}

const testPropsToExclude = ['displayname', 'fieldWidth', 'textInputWrapperWidth', 'marginBottom', 'inlineBlock'];

const TextInputWrapper = styled.div.withConfig({
    shouldForwardProp: (prop) => !testPropsToExclude.includes(prop)
})`
    max-width: 300px;
    width: ${props => props.textInputWrapperWidth ? props.textInputWrapperWidth : '100%'}; 
    display: ${props => props.inlineBlock ? 'inline-block' : 'block'}; 
    position: relative;
    margin-bottom: 20px;

    ${mediaQuery.medium(`
        max-width: 95%;
        width: 95%;
    `)}
    ${mediaQuery.small(`
        max-width: 100%;
        width: 100%;
    `)}

    input[type=text] {
        width: ${props => props.fieldWidth ? props.fieldWidth : '100%'}; 

        padding: 15px 15px 16px 14px;
        margin-bottom: ${props => props.marginBottom ? props.marginBottom : '0px'}; 
        background-color: #FCFCFC;
        border: 1px solid ${definitions.colors.almostBlack};
        font-family: ${definitions.fonts.main};
        font-size: 16px;

        outline: none !important;

        &[value=""] { 
            border-color: ${definitions.colors.almostBlack};
        }

        &:not([value=""]) { 
            border-color: ${definitions.colors.almostBlack};
        }

        &:not([value=""]):not(:focus):not(.is-invalid-input) {
            padding-right: 32px;
            border-color: ${definitions.colors.green};

            & + span {
                font-size: 13px;
                position: absolute;
                top: 50%;
                left: 100%;
                transform: translate(-26px, -50%);
                color: ${definitions.colors.green};

                &:after {
                    ${iconCode.check()}
                }
            }
        }

        &.is-invalid-input {
            border-color: ${definitions.colors.error};
        }

        &:disabled {
            cursor: not-allowed;
            opacity: 0.5;
        }


        ${mediaQuery.small(`
            border-width: 2px;
        `)}
    }

     input[type=text]::placeholder {
        opacity: 1;
        color: ${definitions.colors.almostBlack};
    }
`;

export default control(TextInput);